import { Translations } from '@ts-types/Translations'

const globalTranslations: Translations = {
  en: {
    title_sufix: 'wicadu Help Center',
    contact_point_description:
      'Need assistance? Our support team is ready to help.',
  },
  es: {
    title_sufix: 'Centro de Ayuda de wicadu',
    contact_point_description:
      '¿Necesitas ayuda? Nuestro equipo de soporte está listo para asistirte',
  },
  fr: {
    title_sufix: "Centre d'aide wicadu",
    contact_point_description:
      "Besoin d'aide ? Notre équipe d'assistance est prête à vous aider.",
  },
  pt: {},
}


export default globalTranslations
